"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EmptyState = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Sorry' : _b, message = _a.message;
    return (react_1.default.createElement("div", { className: "p-16 text-center" },
        react_1.default.createElement("div", { className: "uppercase text-blue-dark text-4xl font-bold" }, title),
        react_1.default.createElement("div", { className: "text-blue text-lg font-medium" }, message)));
};
exports.default = EmptyState;
//# sourceMappingURL=index.js.map